module.exports = __webpack_public_path__ + "img/Mic.389fcf67.png";